import { optionsColumn } from '@/global/components/DataGrid/hooks/useDataGridPro'
import ColumnEnum from '@/global/components/DataGrid/utils/columEnum'
import { GridColDefPro } from '@/global/components/DataGrid/utils/types'
import dayjs from 'dayjs'
import OpcoesLog from '../atoms/Opcoes'
import OperacaoChip from '../atoms/OperacaoChip'
import ValueGetterCliente from '../atoms/ValueGetterCliente'

export const columns: GridColDefPro[] = [
    {
        field: 'operacao',
        headerName: 'Operação',
        width: 100,
        type: new ColumnEnum([
            { value: 'INSERT', label: 'Criação (CREATE)' },
            { value: 'READ', label: 'Leitura (READ)' },
            { value: 'UPDATE', label: 'Atualização (UPDATE)' },
            { value: 'DELETE', label: 'Exclusão (DELETE)' },
            { value: 'LOGIN', label: 'Login' },
        ]),
        renderCell: OperacaoChip,
    },
    {
        field: 'ip',
        headerName: 'IP',
        width: 150,
    },
    {
        field: 'clienteId',
        headerName: 'Cliente',
        minWidth: 250,
        flex: 1,
        valueGetter: ValueGetterCliente,
    },
    {
        field: 'email',
        headerName: 'Usuário',
        width: 250,
    },
    {
        field: 'path',
        headerName: 'Path',
        width: 200,
        valueGetter: params => {
            const method = params.row.method

            return `${method} ${params.value}`
        },
    },
    {
        field: 'query',
        headerName: 'Query',
        width: 200,
        valueFormatter: params => {
            const query = JSON.parse(params.value as string)
            return Object.entries(query)
                .map(([key, value]) => `${key}=${value}`)
                .join('&')
        },
    },
    {
        field: 'createdAt',
        headerName: 'Criado em',
        width: 160,
        type: 'datetime-local',
        valueGetter: ({ value }) =>
            dayjs(value).utc().local().format('DD/MM/YYYY HH:mm:ss'),
    },
    {
        ...optionsColumn,
        field: '__opcoes',
        renderCell: OpcoesLog,
    },
]
